export default {
    UNDEFINED: 0,
    CREDIT_CARD: 1,
    BOLETO: 2,
    ONLINE_DEBIT: 3,
    DEBIT_CARD: 4,
    QRCODE: 5,
    PIX: 6,
    QRCODE_DEBIT: 7,
    MULTIBENEFITS: 8,
    PIX_OPEN_FINANCE: 9,
    VOUCHER: 99,
    CLICK_TO_PAY: 100,
    GOOGLE_PAY: 101,
    APPLE_PAY: 102,
};